"use strict";
var distill;
(function (distill) {
    distill.designer = appn.designerv2.designer;
    distill.eventBus = appn.designerv2.eventBus;
    distill.dataCache = appn.designerv2.dataCache;
    distill.componentManager = appn.designerv2.componentManager;
    distill.editors = appn.designerv2.editors;
    distill.canvas = appn.designerv2.canvas;
    distill.elementBuilder = appn.elementBuilder;
    distill.trash = appn.trash;
    distill.toast = appn.toast;
    distill.EVENTS = appn.designerv2.EVENTS;
    distill.EditorBase = appn.designerv2.editors.EditorBase;
    distill.emptyString = appn.emptyString;
})(distill || (distill = {}));
